/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE } from '../config';
import '../styles/movimientofinal.css';
import { useAuth } from '../context/AuthContext';  // Importar el hook para obtener el token

function MovimientoFinalPage() {
  const { scanCode, scanCode2, scanCode3 } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();

  // Estado para la cantidad ingresada
  const [cantidad, setCantidad] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editedBarcode, setEditedBarcode] = useState(scanCode2);
  const [expirationDate, setExpirationDate] = useState('');

  // Función para dividir el código QR en rack y shelf
  const formatCode = (code) => {
    const [rack, shelf] = code.split('-');
    return { rack, shelf };  // 'shelf' es lo que está después del guión
  };

  const { rack: rack1, shelf: shelf1 } = formatCode(scanCode);  // Primer código
  const { rack: rack3, shelf: shelf3 } = formatCode(scanCode3); // Tercer código

  const isFromRecepcion = rack1 === 'RECEPCION';

  // Fetch expiration date from source position when moving from RECEPCION
  useEffect(() => {
    if (!isFromRecepcion) return;

    const fetchExpiration = async () => {
      try {
        const params = new URLSearchParams({
          bar_code: editedBarcode,
          rack: rack1,
          shelf: shelf1,
        });
        const response = await fetch(
          `${API_BASE}/get-position-expiration/?${params}`,
          {
            headers: { 'Authorization': `Token ${token}` },
          }
        );
        if (response.ok) {
          const data = await response.json();
          // The endpoint now returns { batches: [{ batch, expiration_date, quantity }, ...] }
          // ordered FEFO (earliest expiration first). Auto-select the first one so
          // moves consume the soonest-expiring batch by default. The user can still
          // override the date in the form below.
          const firstBatch = data.batches && data.batches[0];
          if (firstBatch && firstBatch.expiration_date) {
            setExpirationDate(firstBatch.expiration_date);
          }
        }
      } catch (error) {
        console.error('Error fetching expiration date:', error);
      }
    };

    fetchExpiration();
  }, [isFromRecepcion, editedBarcode, rack1, shelf1, token]);

  const handleBarcodeEdit = (e) => {
    e.preventDefault();
    if (!editedBarcode.trim()) {
      return;
    }
    setIsEditing(false);
  };

  // Manejar el envío del formulario
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Verifica que la cantidad no esté vacía o sea menor a 1
    if (cantidad <= 0) {
      alert("Por favor, ingresa una cantidad válida mayor a 0.");
      return;
    }

    // Prepara los datos para enviar
    const data = {
      bar_code: editedBarcode,
      from_rack: rack1,  // Rack de origen
      from_shelf: shelf1,  // Shelf de origen
      quantity: Number(parseFloat(cantidad).toFixed(3)),  // Convertir a número con 3 decimales
      to_rack: rack3,  // Rack de destino
      to_shelf: shelf3  // Shelf de destino
    };

    // Include expiration_date if provided (from recepcion flow)
    if (expirationDate) {
      data.expiration_date = expirationDate;
    }

    // Imprimir los datos a la consola para ver lo que se está enviando
    console.log('Datos a enviar:', data);
    console.log('Tipo de cantidad:', typeof data.quantity);

    try {
      // Realiza la solicitud POST al endpoint
      const response = await fetch(`${API_BASE}/move-stock/`, {
        method: 'POST',
        headers: {
            'Authorization': `Token ${token}`,  // Enviar el token en el header
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      // Verifica si la respuesta fue exitosa
      if (response.ok) {
        const responseData = await response.json();
        console.log('Datos enviados con éxito:', responseData);
        alert("Producto movido con éxito.");
        window.location.href = '/storage'; // Redirige a /storage después de cerrar la alerta
      }
      else {
        const errorData = await response.json();
        console.error('Error al enviar los datos:', errorData);
        console.error('Status:', response.status);
        console.error('Status Text:', response.statusText);
        // Show the specific error message from the backend
        alert(errorData.error || "Hubo un error al mover el producto. Intenta nuevamente.");
      }
    } catch (error) {
      console.error('Error de red:', error);
      alert("Hubo un error en la conexión. Intenta nuevamente.");
    }
  };

  return (
    <div className="movimiento-final-page">
      <button
        className="back-button"
        onClick={() => navigate(`/storage/movimiento/${scanCode.trim()}/${scanCode2.trim()}`)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '8px' }}
      >
        <span className='arrow'>&larr;</span>
      </button>
      <h3 className="movimiento-final-title">Detalle del Movimiento</h3>

      <div className="movimiento-final-detail">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <p><strong>Código de barras del producto:</strong></p>
          {isEditing ? (
            <form onSubmit={handleBarcodeEdit} style={{ display: 'flex', gap: '10px', flex: 1 }}>
              <input
                type="text"
                value={editedBarcode}
                onChange={(e) => setEditedBarcode(e.target.value)}
                style={{
                  padding: '4px 8px',
                  borderRadius: '4px',
                  border: '1px solid #cce7f3',
                  flex: 1
                }}
                autoFocus
              />
              <button
                type="submit"
                style={{
                  padding: '4px 8px',
                  background: '#5cb3d6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Guardar
              </button>
            </form>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span>{editedBarcode}</span>
              <button
                onClick={() => setIsEditing(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px',
                  color: '#5cb3d6'
                }}
              >
                ✎
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="movimiento-final-detail">
        <p><strong>Ubicación donde retirarás producto:</strong> {rack1} - {shelf1}</p>
      </div>

      <div className="movimiento-final-detail">
        <p><strong>Ubicación donde agregarás producto:</strong> {rack3} - {shelf3}</p>
      </div>

      <div className="movimiento-final-form-container">
        <h4 className="movimiento-final-form-title">Agregar Producto</h4>
        <form onSubmit={handleSubmit} className="movimiento-final-form">
          <div className="movimiento-final-input-container">
            <label htmlFor="cantidad" className="movimiento-final-label">Cantidad:</label>
            <input
              type="number"
              id="cantidad"
              name="cantidad"
              min="0.001"
              step="0.001"
              placeholder="Ingresa cantidad"
              required
              className="movimiento-final-input"
              value={cantidad}
              onChange={(e) => {
                const value = e.target.value;
                // Validar que no tenga más de 3 decimales
                if (value === '' || /^\d*\.?\d{0,3}$/.test(value)) {
                  setCantidad(value);
                }
              }}
            />
          </div>
          {isFromRecepcion && (
            <div className="movimiento-final-input-container">
              <label htmlFor="expirationDate" className="movimiento-final-label">Fecha de Vencimiento:</label>
              <input
                type="date"
                id="expirationDate"
                className="movimiento-final-input"
                value={expirationDate}
                onChange={(e) => setExpirationDate(e.target.value)}
              />
            </div>
          )}
          <button type="submit" className="movimiento-final-submit-btn">Enviar</button>
        </form>
      </div>
    </div>
  );
}

export default MovimientoFinalPage;
